<template>
  <dynamic-zone-renderer v-if="content" :components="content.components" :add-paddings="false"/>
</template>

<script>


import DynamicZoneRenderer from "../../../../renderer/DynamicZoneRenderer";
import analysisQueryMixin from "../../../../../mixins/AnalysisQueryMixin";
export default{
  components: {DynamicZoneRenderer},
  mixins: [analysisQueryMixin],
  props:{
    activation: String,
    type: String,
    tone: String,
    color: Number
  },
  data(){
    return{
      content: null,
    }
  },
  created(){
    this.getColorToneComboData();
  },
  methods:{
    getColorToneComboData(){
      let url = `/advanced-color-tones/${this.activation}.${this.type}.${this.color}.${this.tone}`;
      this.getContent('content', url);
    }
  }

}
</script>